import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale, width } from '@components/frame';
import { Feedback, isAndroid, isTabletOrWeb, isWeb } from '@helpers';

import Svg from '@styles/icons/svg';
import Button from '@styles/buttons';
import { font } from '@styles/fonts';
import BackButton from '@components/common/backButton';
import { BULLET } from '@v2/pages/common/constants/base.constants';

export default (props) => {
  const { validateUserAction, C, setMode, data, MODES } = props;
  const isAuto = data.automaticControl;
  const suggested = data.suggestedConnectionMethod;

  const TEXT_GAP = 24;

  const getTextStyles = (warning) => [
    { color: C(warning ? 'Label/Light/Error' : 'Label/Light/Primary'), width: '100%' },
    font[warning ? 'Subhead 1 bold' : 'Subhead 1'],
    { lineHeight: scale(25) },
  ];

  const listBulletStyles = { marginLeft: scale(10), color: C('Label/Light/Primary'), fontSize: scale(20), transform: [{ translateY: scale(-1) }] };

  const basicTextStyles = getTextStyles(false);
  const warningTextStyles = getTextStyles(true);

  const headerText = () => {
    if (suggested) {
      return 'Before Connecting to Heidenhain';
    }

    // if (isAuto) {
    //   return 'Automatic Connection Failed';
    // }

    return 'Machine Connection Failed';
  };

  const middleText = () => {
    // if (isAuto) {
    //   return (
    //     <View style={{ gap: scale(TEXT_GAP) }}>
    //       <Text style={basicTextStyles}>{i18n.t(`We couldn't establish a connection with the Heidenhain control using Option 18.`)}</Text>
    //     </View>
    //   );
    // }

    if (suggested) {
      return (
        <View style={{ gap: TEXT_GAP }}>
          <View>
            <View style={{ flexDirection: 'row', gap: scale(6) }}>
              <Text style={listBulletStyles}>{BULLET}</Text>
              <Text style={basicTextStyles}>
                {i18n.t(
                  'The Smart Factory connection may interfere with other active connections to the Heidenhain control, such as from machine automation systems or software like Soflex.'
                )}
              </Text>
            </View>
            <View style={{ flexDirection: 'row', gap: scale(6) }}>
              <Text style={listBulletStyles}>{BULLET}</Text>
              <Text style={basicTextStyles}>{i18n.t('To avoid disruptions, we recommend connecting only when the machine is not running.')}</Text>
            </View>
          </View>
        </View>
      );
    }

    return null;

    // return (
    //   <View style={{ gap: scale(24) }}>
    //     <Text style={basicTextStyles}>
    //       {i18n.t('Cannot establish connection to')} {data.endpoint}
    //     </Text>
    //     <Text style={[{ color: C('Label/Light/Tertiary') }, font.Body]}>{i18n.t('Smart Factory can connect to')}: Heidenhain</Text>
    //     <Text style={[{ color: C('Label/Light/Tertiary') }, font.Body]}>Siemens (with OPC UA option) Fanuc</Text>
    //   </View>
    // );
  };

  const buttonText = () => {
    // return 'Try Heidenhain LSV2'
    if (suggested) {
      return `Proceed`;
    }

    if (isAuto) {
      return 'Select Machine Control';
    }

    return 'Report to Smart Factory';
  };

  return (
    <View style={{ paddingHorizontal: scale(3), paddingTop: scale(suggested ? 0 : 15) }}>
      <View style={[{ paddingTop: scale(suggested ? 0 : 20), paddingHorizontal: scale(49) }, isTabletOrWeb && { paddingBottom: scale(20) }]}>
        {!suggested && (
          <View style={{ alignItems: 'center', flex: 1 }}>
            <Svg icon={'errorBig'} width={scale(44)} height={scale(40)} color={C('Label/Light/Error')} />
          </View>
        )}
        <Text
          style={[
            {
              color: C('Label/Light/Primary'),
              width: '100%',
              textAlign: 'center',
              marginTop: scale(isWeb ? 16 : 56),
              textAlign: suggested ? 'left' : 'center',
            },
            font.Headline,
          ]}
        >
          {i18n.t(headerText())}
        </Text>
        <View style={{ maxWidth: width, marginTop: scale(TEXT_GAP) }}>{middleText()}</View>
        <View style={{ marginTop: scale(35), justifyContent: 'flex-end' }}>
          <Button
            {...{
              variant: 'Dialog M',
              borderRadius: scale(12),
              type: 'Primary',
              onPress: async () => {
                if (suggested) {
                  await validateUserAction({
                    ...data,
                    automaticControl: false,
                    machineBrandCode: null,
                    connectionMethodCode: suggested,
                    connectionMethodName: suggested,
                  });
                  return;
                }

                if (isAuto) {
                  return setMode(MODES.MACHINE_CONTROL);
                }
                return Feedback({ type: 'error' });
              },
            }}
          >
            {i18n.t(buttonText())}
          </Button>
        </View>
      </View>
    </View>
  );
};
